var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 125.58 125.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#f4f3f4;}.cls-4{fill:#e6141e;}.cls-5{clip-path:url(#clippath-1);}.cls-6{clip-path:url(#clippath-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 125.58,
    height: 125.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 125.58,
    height: 125.58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 125.58,
    height: 125.58
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m62.79,125.58c34.68,0,62.79-28.11,62.79-62.79S97.47,0,62.79,0,0,28.11,0,62.79s28.11,62.79,62.79,62.79"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m77.02,82.14c6.22-4.29,10.29-11.31,10.29-19.22s-4.07-14.93-10.29-19.22c19.5,4.22,29.04,16.14,31.22,19.22-2.18,3.08-11.72,15-31.22,19.22m-59.7-19.22c2.12-3.08,11.57-15.19,31.38-19.32-6.3,4.28-10.43,11.34-10.43,19.32s4.12,15.03,10.42,19.31c-19.75-4.14-29.24-16.24-31.37-19.31m45.4,20.71c-11.82-.04-21.42-9.31-21.42-20.71s9.6-20.68,21.42-20.71c.18,0,.36,0,.54,0,11.64.24,21.03,9.43,21.03,20.7s-9.39,20.46-21.03,20.7c-.18,0-.36,0-.54,0m48.63-21.44c-.22-.37-2.48-4.02-7.25-8.31.01,0,.03-.02.04-.03l2.9-2.79c.59-.57.59-1.49,0-2.06-.59-.57-1.55-.57-2.14,0l-2.9,2.79c-.06.06-.11.12-.16.18-1.92-1.53-4.14-3.09-6.71-4.57.03-.05.07-.09.09-.14l2.97-5.59c.38-.72.09-1.59-.66-1.96-.74-.37-1.65-.08-2.03.63l-2.97,5.59s-.01.04-.02.06c-3.23-1.64-6.92-3.12-11.1-4.27.03-.07.06-.14.08-.21l1.96-7.93c.19-.78-.31-1.57-1.12-1.75-.81-.19-1.63.3-1.82,1.08l-1.96,7.93c-.01.05-.01.11-.02.16-4.04-.91-8.49-1.51-13.39-1.66,0-.02,0-.03,0-.05v-10.03c0-.81-.68-1.46-1.51-1.46s-1.51.65-1.51,1.46v10.03s0,0,0,0c-5.29.03-10.08.58-14.39,1.48l-1.94-7.87c-.19-.78-1.01-1.27-1.82-1.08-.81.19-1.31.97-1.12,1.75l1.95,7.89c-4.22,1.1-7.94,2.53-11.21,4.14l-2.8-5.27c-.38-.72-1.29-1-2.03-.63-.74.37-1.04,1.25-.66,1.96l2.83,5.34c-2.62,1.47-4.9,3.03-6.85,4.57l-2.68-2.59c-.59-.57-1.55-.57-2.14,0-.59.57-.59,1.49,0,2.06l2.53,2.44c-5.01,4.45-7.34,8.32-7.56,8.7-.26.44-.26.98,0,1.43.54.93,13.76,22.92,48.4,22.92.03,0,.06,0,.09,0,.02,0,.05,0,.07,0,.24,0,.47-.01.71-.02,33.98-.37,47.3-21.96,47.86-22.88.27-.45.27-1.01,0-1.46"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m62.79,70.94c-4.59,0-8.32-3.6-8.32-8.02,0-.51.05-1.01.14-1.51.54.13,1.09.19,1.65.19,3.81,0,6.9-2.99,6.9-6.65v-.05c4.42.19,7.94,3.71,7.94,8.02s-3.73,8.02-8.32,8.02m0-18.96c-.56,0-1.07.04-1.58.11-.43.06-.82.31-1.05.67-.23.36-.29.8-.16,1.2.1.31.15.63.15.99,0,2.06-1.74,3.74-3.88,3.74-.68,0-1.31-.16-1.89-.48-.38-.21-.84-.25-1.25-.11-.41.14-.74.44-.91.84-.52,1.25-.78,2.59-.78,3.98,0,6.03,5.09,10.94,11.35,10.94s11.35-4.91,11.35-10.94-5.09-10.94-11.35-10.94"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.87eee354fb0085bda6567ea1f5606805.svg";
export { ForwardRef as ReactComponent };